import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/useAuthStore'
import DashboardView from '../views/DashboardView.vue'
import ProductListView from '../views/products/ProductListView.vue'
import ProductFormView from '../views/products/ProductFormView.vue'
import MovementFormView from '../views/inventory/MovementFormView.vue'
import InventoryView from '../views/inventory/InventoryView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/auth/LoginView.vue'),
      meta: { public: true }
    },
    {
      path: '/',
      name: 'dashboard',
      component: DashboardView,
      meta: { requiresAuth: true }
    },
    {
      path: '/sales',
      name: 'sales',
      component: () => import('../views/sales/SalesListView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/sales/new',
      name: 'sales-new',
      component: () => import('../views/sales/NewSaleView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/products',
      name: 'products',
      component: ProductListView,
      meta: { requiresAuth: true }
    },
    {
      path: '/products/new',
      name: 'product-new',
      component: ProductFormView,
      meta: { requiresAuth: true }
    },
    {
      path: '/products/:id/edit',
      name: 'product-edit',
      component: ProductFormView,
      meta: { requiresAuth: true }
    },
    {
      path: '/products/:id',
      name: 'product-detail',
      component: ProductFormView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: InventoryView,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/movement',
      name: 'movement-form',
      component: MovementFormView,
      meta: { requiresAuth: true }
    },
    {
      path: '/warehouses',
      name: 'warehouses',
      component: () => import('../views/warehouses/WarehouseListView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/warehouses/new',
      name: 'warehouse-new',
      component: () => import('../views/warehouses/WarehouseFormView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/warehouses/:id/edit',
      name: 'warehouse-edit',
      component: () => import('../views/warehouses/WarehouseFormView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('../views/auth/ChangePasswordView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue')
    }
  ]
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  if (to.name === 'login' && authStore.isAuthenticated) {
    return { name: 'dashboard' }
  }
})

export default router
